import React from 'react'
import { Check, XCircle, Plus } from 'lucide-react'

const MOCK_INC = `<ul>
  <li>All meals as mentioned in the itinerary
    <ul>
      <li>Breakfast, lunch and dinner</li>
      <li>Welcome drink and daily fresh fruit</li>
    </ul>
  </li>
  <li>Kayaking and all water activity equipment</li>
  <li>English-speaking cruise guide</li>
  <li>Cave entrance fees</li>
  <li>Accommodation in selected cabin type</li>
</ul>`

const MOCK_EXC = `<ul>
  <li>International and domestic flights</li>
  <li>Travel insurance</li>
  <li>Personal expenses and tips</li>
  <li>Alcoholic beverages (available for purchase)</li>
  <li>Spa treatments</li>
</ul>`

function domLiToNode(li) {
  const children = []
  const subUl = li.querySelector(':scope > ul')
  if (subUl) {
    subUl.querySelectorAll(':scope > li').forEach(child => children.push(domLiToNode(child)))
    subUl.remove()
  }
  return { text: li.textContent.trim(), children }
}

function parseListItems(data) {
  if (!data) return []
  if (Array.isArray(data)) {
    return data.map(d => ({ text: typeof d === 'object' ? d.item : d, children: [] })).filter(n => n.text)
  }
  if (typeof data === 'string' && !data.includes('<')) {
    return data.split('\n').map(s => s.trim()).filter(Boolean).map(text => ({ text, children: [] }))
  }
  const doc = new DOMParser().parseFromString(data, 'text/html')
  const items = []
  doc.querySelectorAll('body > ul > li').forEach(li => items.push(domLiToNode(li)))
  return items
}

function ItemList({ items, type }) {
  const isInc = type === 'inc'
  return (
    <ul className="si-inc-exc__list">
      {items.map((item, i) => (
        <li key={i} className={`si-inc-exc__item si-inc-exc__item--${type}`}>
          {isInc
            ? <Check size={16} strokeWidth={1.5} />
            : <XCircle size={16} strokeWidth={1.5} />
          }
          <span>
            {item.text}
            {item.children.length > 0 && (
              <ul className="si-inc-exc__sublist">
                {item.children.map((child, j) => (
                  <li key={j} className="si-inc-exc__subitem">
                    <Plus size={12} strokeWidth={1.5} />
                    <span>{child.text}</span>
                  </li>
                ))}
              </ul>
            )}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default function InclusionExclusion({ inclusions, exclusions }) {
  const incItems = parseListItems(inclusions).length ? parseListItems(inclusions) : parseListItems(MOCK_INC)
  const excItems = parseListItems(exclusions).length ? parseListItems(exclusions) : parseListItems(MOCK_EXC)

  return (
    <section className="si-section">
      <h2 className="ljn-section-title">Inclusions & Exclusions</h2>
      <div className="ljn-divider" style={{ marginBottom: 28 }} />
      <div className="si-inc-exc">
        <div className="si-inc-exc__col">
          <div className="si-inc-exc__heading si-inc-exc__heading--inc">What's Included</div>
          <ItemList items={incItems} type="inc" />
        </div>
        <div className="si-inc-exc__col">
          <div className="si-inc-exc__heading si-inc-exc__heading--exc">Not Included</div>
          <ItemList items={excItems} type="exc" />
        </div>
      </div>
    </section>
  )
}
